<template>
  <div>
    <v-breadcrumbs
      :items="breadcrumbs"
      class="grey lighten-2 white--text"
    ></v-breadcrumbs>
    <v-progress-circular
      v-if="loading"
      :size="100"
      :width="4"
      color="fmq_black"
      indeterminate
      class="d-flex mx-auto py-8 mt-8"
    ></v-progress-circular>
    <div v-else>
      <div class="pa-4">
        <div class="d-flex justify-space-between align-center mb-4">
          <v-btn
            small
            depressed
            color="fmq_gray"
            dark
            outlined
            to="/anatomias-fisiologias"
          >
            <v-icon small> mdi-arrow-left </v-icon>Voltar</v-btn
          >
        </div>
        <AnatomiasFisiologiasFormulario @send="editar" :item="item" />
      </div>
    </div>
    <AlertSuccess
      :dialog="success"
      dialogMessage="Anatomia e Fisiologia criada com sucesso"
      @close="goTo"
    />
    <AlertError :alertError="error" :messageError="messageError" />
  </div>
</template>

<script>
import { storeAnatomyPhysiology } from "@/services/anatomy-physiology.js";
import AnatomiasFisiologiasFormulario from "@/components/anatomias-fisiologias/AnatomiasFisiologiasFormulario.vue";
export default {
  name: "AnatomiasFisiologiasCriar",
  components: { AnatomiasFisiologiasFormulario },
  data: () => ({
    breadcrumbs: [
      {
        text: "Anatomias e Fisiologias",
        disabled: false,
        to: "/anatomias-fisiologias",
      },
      {
        text: "Criar Anatomia e Fisiologia",
        disabled: true,
        to: "",
      },
    ],
    error: false,
    success: false,
    loadingBtn: false,
    messageError: null,
    item: {},
    loading: false,
  }),
  methods: {
    async editar(event) {
      this.error = false;
      this.sucess = false;
      this.loadingBtn = true;
      try {
        await storeAnatomyPhysiology(event).then(() => {
          this.success = true;
        });
        this.loadingBtn = false;
      } catch (e) {
        this.loadingBtn = false;
        this.error = true;
        this.messageError = e.response.data.message;
      }
    },
    goTo() {
      this.sucess = false;
      this.$router.push({ name: "AnatomiasFisiologias" });
    },
  },
};
</script>

<style></style>
